import "../style/footer.css";

export default function Footer(){
    const year = () => {
        const d = new Date(Date.now());
        return d.getFullYear();
    }
  
    return (
        <footer>
            <a href="https://tkwebdev.ca" target="_blank" rel="noopener noreferrer">
                Tony Kieling - { year() }
            </a> 
        </footer>
    );
}